import { useEffect, useState } from "react";
import { useAxios } from "@hooks";
import { estimateClockOffset } from "../components/exam-period/monitor/examTimer";

/**
 * Procjenjuje offset sata klijent↔server (Cristian's algorithm) i kešira ga na
 * razini modula, da se za sve retke monitoringa izračuna SAMO jednom.
 * Vrijednost: serverClock − clientClock (ms).
 */
let cachedOffsetMs: number | null = null;
let inflight: Promise<number> | null = null;

export function useClockOffset(): number {
  const axios = useAxios();
  const [offset, setOffset] = useState<number>(cachedOffsetMs ?? 0);

  useEffect(() => {
    if (cachedOffsetMs !== null) {
      setOffset(cachedOffsetMs);
      return;
    }

    if (!inflight) {
      inflight = estimateClockOffset(async () => {
        const res = await axios.get<{ unixMs: number }>("/api/time");
        return res.data.unixMs;
      }, 3)
        .then((r) => {
          cachedOffsetMs = r.offsetMs;
          return r.offsetMs;
        })
        .catch(() => {
          cachedOffsetMs = 0;
          return 0;
        });
    }

    let mounted = true;
    inflight.then((o) => {
      if (mounted) setOffset(o);
    });
    return () => {
      mounted = false;
    };
  }, [axios]);

  return offset;
}
